/* oxlint-disable */
'use client';

import React, {
  useCallback, useEffect, useRef, useState,
} from 'react';

// import { useAuthStore } from '@/stores/userStore';
import { useRouter } from 'next/navigation';
import Script from 'next/script';

import { MdSportsSoccer } from 'react-icons/md';

import { useAuthStore } from '@/stores/userStore';
import { userUIStore } from '@/stores/userUIStore';

import BannerCasino from '../banner/BannerCarousel';
import SWSmoothCarouselFavorites from '../banner/SWSmoothCarouselFavorites';
import { useToast } from '../ui/use-toast';

// Definición de interfaces para los juegos

const FavoriteTab = ({ banners }: { banners: any }) => {
  const [isScriptLoaded, setIsScriptLoaded] = useState<boolean>(false);
  const scriptUrl = process.env.NEXT_PUBLIC_SCRIPT_URL as string;
  const widgetRef = useRef(null);
  const retryCountRef = useRef(0);
  const integration = process.env.NEXT_PUBLIC_ALTENAR_INTEGRATION as string;
  const maxRetries = 5;
  const retryDelay = 1000;
  const { toast } = useToast();
  const { isSidebarOpen } = userUIStore();

  const { account } = useAuthStore();
  const router = useRouter();

  useEffect(() => {
    if (account?.contingencies?.casino || account?.contingencies?.bets) {
      const contingency = account?.contingencies?.casino ? 1 : 2;
      router.push(`/?cont=${contingency}`);
    }
  }, [account, router]);

  const initAltenar = useCallback(async () => {
    if ((window as any).altenarWSDK && typeof (window as any).altenarWSDK.init === 'function') {
      const initConfig = {
        integration,
        culture: 'es-ES',
        themeName: 'dark',
      };
      (window as any).altenarWSDK.init(initConfig);

      widgetRef.current = (window as any).altenarWSDK.addWidget({
        widget: 'WFavouriteEvents',
        props: {
          onEventSelect: (selected: any) => {
            (window as any).location.href = `/sports?event=${selected.event.id}`;
          },
        },
        container: document.getElementById('sportsfavorites'),
      });
    } else if (retryCountRef.current < maxRetries) {
      retryCountRef.current++;
      setTimeout(initAltenar, retryDelay);
    } else {
      toast({
        title: 'Error al cargar los favoritos',
        description: 'Inténtalo más tarde',
      });
    }
  }, [integration, toast]);

  useEffect(() => {
    if (isScriptLoaded) {
      initAltenar();
    }

    return () => {
      if (widgetRef.current) {
        (widgetRef.current as any).remove();
      }
    };
  }, [isScriptLoaded, initAltenar]);

  return (
    <>
      <Script
        src={`${scriptUrl}/altenarWSDK.js`}
        strategy="lazyOnload"
        onLoad={() => {
          setIsScriptLoaded(true);
        }}
      />
      <div
        className={`${!isSidebarOpen ? 'pl-72' : 'pl-20'} w-full pt-24 max-md:pl-0`}
      >
        <div
          className="text-sivarbet-text flex flex-col items-stretch w-full"
          id="mainTab"
          role="tabpanel"
          tabIndex={0}
        >
          <BannerCasino banners={banners} />
          <div className="flex flex-col items-stretch w-full pt-5">
            <div className="flex items-center justify-between mt-5 pb-3">
              <div className="flex items-center gap-2 text-lg font-medium text-sivarbet-text">
                <MdSportsSoccer className="text-2xl" />
                <h2 className="text-sivarbet-text text-2xl">
                  Mis Deportes Favoritos
                </h2>
              </div>
            </div>
            <div className="mt-5" id="sportsfavorites" />
            <SWSmoothCarouselFavorites />
          </div>
        </div>
      </div>
    </>
  );
};

export default FavoriteTab;
